<template lang="pug">
  .app
    app-header
    .app__scroll
      vue-scroll
        .app__wrapper
          .container
            router-view
    v-dialog(
      max-width="1400" 
      v-model="onboardingModalVisible"
    )
      onboarding-modal(
        v-if="currentOnboardingItem"
        :item="currentOnboardingItem"
        @close="closeOnboardingModal"
        @open-notion="handleOpenNotion"
      )
    v-dialog(
      max-width="1800" 
      v-model="onboardingNotionModalVisible"
    )
      onboarding-notion-modal(
        v-if="showOnboardingNotionModal"
        :item="currentOnboardingNotionItem"
        @close="closeOnboardingNotionModal"
      )
    v-dialog(
      max-width="1080" 
      v-model="gettingStartedModalVisible"
    )
      GettingStartedModal(
        @close="closeGettingStartedModal"
        @started="handleGettingStarted"
      )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppHeader from '@/components/layouts/app-header/AppHeader'
import OnboardingModal from '@/components/globalModals/OnboardingModal.vue'
import OnboardingNotionModal from '@/components/globalModals/OnboardingNotionModal.vue'
import GettingStartedModal from '@/components/globalModals/GettingStartedModal.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    OnboardingModal,
    OnboardingNotionModal,
    GettingStartedModal
  },
  data () {
    return {
      getStartedModal: false
    }
  },
  computed: {
    ...mapGetters('onboarding', [
      'showOnboardingModal',
      'currentOnboardingItem',
      'showOnboardingNotionModal',
      'currentOnboardingNotionItem',
    ]),

    onboardingModalVisible: {
      get () {
        return this.showOnboardingModal
      },
      set (value) {
        if (!value) {
          this.closeOnboardingModal()
        }
      }
    },

    onboardingNotionModalVisible: {
      get () {
        return this.showOnboardingNotionModal
      },
      set (value) {
        if (!value) {
          this.closeOnboardingNotionModal()
        }
      }
    },

    gettingStartedModalVisible: {
      get () {
        return this.getStartedModal
      },
      set (value) {
        if (!value) {
          this.closeGettingStartedModal()
        } else {
          this.getStartedModal = value
        }
      }
    }
  },
  methods: {
    ...mapActions('onboarding', [
      'closeOnboardingModal',
      'openOnboardingNotionModal',
      'closeOnboardingNotionModal'
    ]),

    handleOpenNotion () {
      const item = this.currentOnboardingItem
      this.closeOnboardingModal()
      this.openOnboardingNotionModal(item)
    },

    isGettingStartedCompleted () {
      return localStorage.getItem('profeed_getting_started_completed') === 'true'
    },

    openGettingStartedModal () {
      this.getStartedModal = true
    },

    closeGettingStartedModal () {
      try {
        localStorage.setItem('profeed_getting_started_completed', 'true')
      } catch (error) {
        console.error('App: localStorage error:', error)
      }
      this.getStartedModal = false
    },

    handleGettingStarted () {
      try {
        localStorage.setItem('profeed_getting_started_completed', 'true')
      } catch (error) {
        console.error('App: localStorage error in handleGettingStarted:', error)
      }
      this.getStartedModal = false

      this.$toasted.success(this.$t('onboarding.welcome'))
    },

    checkShouldShowGettingStarted () {
      if (!this.isGettingStartedCompleted()) {
        setTimeout(() => {
          this.openGettingStartedModal()
        }, 500)
      }
    }
  },

  async mounted () {
    this.checkShouldShowGettingStarted()
  },

  watch: {
    '$route' () {
      this.checkShouldShowGettingStarted()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_mixins.scss';

.app {
  &__scroll {
    height: 100vh;
    padding-top: 7rem;
  }

  &__wrapper {
    padding-top: 4rem;
    padding-bottom: 4rem;

    @include mobile {
      padding: 2.5rem 0;
    }
  }
}
</style>